import { Box, LinearProgress, Typography } from "@mui/material";

const DeclarationProgress = ({
	checkedCount,
	totalCount,
	value,
}: {
	checkedCount: number;
	totalCount: number;
	value: number;
}) => {

	const getColor = () => {
		if (value === 0) {
			return "inherit";
		}
		if (value > 0 && value === 100) {
			return "success";
		}
		return "info";
	};

	return (
		<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
			<Box sx={{ width: "100%" }}>
				<LinearProgress
					variant="determinate"
					color={getColor()}
					value={value}
					sx={{ height: 8, borderRadius: 4 }}
				/>
			</Box>

			<Typography variant="body2" color="text.secondary" sx={{ fontSize: 11, width: 40, whiteSpace: "nowrap" }}>
				{`${checkedCount} / ${totalCount}`}
			</Typography>
		</Box>
	);
};

export default DeclarationProgress;
